var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.494,
    height: 40.128,
    viewBox: "0 0 43.494 40.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(-283.063 -119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON",
    transform: "translate(283.063 118.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M45.738,3.5H3.749a.75.75,0,1,0,0,1.5H5.378a2.237,2.237,0,0,0-.128.75v7.63a.75.75,0,1,0,1.5,0V8.374H39.739a.75.75,0,0,0,0-1.5H6.748V5.75A.75.75,0,0,1,7.5,5H41.993a.75.75,0,0,1,.75.75V28.619a.75.75,0,0,1-.75.75H24.747v1.5H41.993a2.25,2.25,0,0,0,2.25-2.25V5.75A2.237,2.237,0,0,0,44.114,5h1.629a.75.75,0,0,0,0-1.5ZM31.117,27.119h8.623a.75.75,0,0,0,0-1.5H31.117a.75.75,0,0,0,0,1.5ZM28.492,23.37H39.739a.75.75,0,0,0,0-1.5H28.492a.75.75,0,1,0,0,1.5Zm0-3.749H39.739a.75.75,0,0,0,0-1.5H28.492a.75.75,0,1,0,0,1.5Zm0-3.749H39.739a.75.75,0,0,0,0-1.5H28.492a.75.75,0,1,0,0,1.5Zm-5.249-3.749h16.5a.75.75,0,0,0,0-1.5h-16.5a.75.75,0,0,0,0,1.5Z",
    transform: "translate(-2.972 -3.499)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(285.967 130.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "professional_publications",
    "data-name": "professional publications",
    d: "M16.341,11.616a.479.479,0,1,0-.452-.479A.479.479,0,0,0,16.341,11.616Zm0,3.723a.479.479,0,1,1-.452.479.479.479,0,0,1,.452-.479Zm0-2.338a.477.477,0,1,1-.339.14.479.479,0,0,1,.339-.14Zm0-5.754a2.728,2.728,0,1,0-2.667-2.729,2.728,2.728,0,0,0,2.667,2.729Zm0-4.5a1.774,1.774,0,1,1-1.705,1.774,1.774,1.774,0,0,1,1.705-1.774Zm-6.316,8.623v7.318A1.764,1.764,0,0,0,12.6,20.238v8.378a2.128,2.128,0,0,0,3.745,1.325,2.128,2.128,0,0,0,3.742-1.325V13.383a1.731,1.731,0,0,1,.507-1.227L26.75,5.967a1.763,1.763,0,0,0-2.491-2.491L20.054,7.682a2.2,2.2,0,0,1-1.549.646H13.067a3.049,3.049,0,0,0-3.04,3.039Zm3.521,7.269h5.581v9.98a1.157,1.157,0,0,1-2.314,0V20.3a.479.479,0,0,0-.958,0v8.315a1.157,1.157,0,0,1-2.314,0Zm-2.568-7.268a2.1,2.1,0,0,1,2.1-2.1H18.5a3.154,3.154,0,0,0,2.217-.92l4.211-4.2a.809.809,0,0,1,1.143,1.135l-6.152,6.189a2.683,2.683,0,0,0-.785,1.9v4.3H13.546V11.814a.479.479,0,0,0-.958,0v6.872a.809.809,0,0,1-1.616,0Z",
    transform: "translate(-10.025 -1.793)",
    stroke: "#fff",
    strokeWidth: 0.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.836c0a9972c7aec9318500a30899c36a.svg";
export { ForwardRef as ReactComponent };